import { usePostHog } from "posthog-js/react";
import { useRef } from "react";
import { useEffect } from "react";

export function useTrackProfilePageViewed() {
  const posthog = usePostHog();
  const once = useRef(false);

  useEffect(() => {
    if (once.current) return;
    once.current = true;
    posthog.capture("profile_page_viewed");
  }, [posthog]);
}

export function useTrackProfileActions() {
  const posthog = usePostHog();

  const trackSettingsClicked = () => {
    posthog.capture("profile_settings_clicked");
  };

  const trackLogoutClicked = () => {
    posthog.capture("profile_logout_clicked");
  };

  const trackDeleteAccountClicked = () => {
    posthog.capture("profile_delete_account_clicked");
  };

  const trackManageBillingClicked = () => {
    posthog.capture("profile_manage_billing_clicked");
  };

  return {
    trackSettingsClicked,
    trackLogoutClicked,
    trackDeleteAccountClicked,
    trackManageBillingClicked,
  };
} 